
















import Vue from 'vue';

type Invoice = {
  id: number;
  invoice_status: string;
  created_at: number;
  items: [
    {
      title: string;
      quant: number;
    },
  ];
};

export default Vue.extend({
  name: 'invoiceDetails',
  data: () => ({
    state: false,
    products: [] as { title: string; quant: number }[],
  }),
  methods: {
    open(invoice: Invoice): void {
      this.products = invoice.items;
      this.state = true;
    },
  },
});
